import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { HeaderContext } from 'app/containers/Header'
import { useVocabularyData } from 'app/utils/vocabulary'
import React, { memo, useContext } from 'react'
import { isMobile } from 'react-device-detect'

export interface Props {
  modalStatus?: boolean
  startAnimation?: boolean
}

export const Contacts = memo(function Contacts({
  modalStatus,
  startAnimation,
}: Props) {
  const { address, email, languageCode, phone } = useContext(
    HeaderContext,
  ) as any

  return (
    <Container
      className={modalStatus && startAnimation ? 'open' : undefined}
      row
    >
      {address ? (
        <Item>
          <Label>{useVocabularyData('visit', languageCode)}</Label>
          <Address dangerouslySetInnerHTML={{ __html: address }} />
        </Item>
      ) : null}

      {email || phone ? (
        <Item>
          <Label>{useVocabularyData('contact-us', languageCode)}</Label>

          {phone ? (
            <Anchor
              href={`tel:${phone}`}
              onClick={() => {
                if (isMobile) {
                  typeof window.gtag !== 'undefined' &&
                    window.gtag('event', 'Click', {
                      event_category: 'Website',
                      event_label: 'Phone Number',
                    })
                }
              }}
            >
              {phone}
            </Anchor>
          ) : null}

          {email ? (
            <Anchor
              href={`mailto:${email}`}
              onClick={() => {
                typeof window.gtag !== 'undefined' &&
                  window.gtag('event', 'Click', {
                    event_category: 'Website',
                    event_label: 'Email Address',
                  })
              }}
            >
              {email}
            </Anchor>
          ) : null}
        </Item>
      ) : null}
    </Container>
  )
})

const Item = styled.div`
  font-size: 0.875rem;
  line-height: 1.375rem;
  opacity: 0;
  transform: translateY(1.875rem);
  &:nth-of-type(2) {
    margin-left: 7.083vw;
  }
`

const Label = styled.div`
  font-size: 0.625rem;
  letter-spacing: 0.1em;
  line-height: 0.875rem;
  opacity: 0.3;
  margin-bottom: 1.25rem;
  text-transform: uppercase;
`

const Address = styled.div``

const Anchor = styled.a`
  display: block;
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.4;
  }
`

const Container = styled(FlexBox)`
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-weight: 300;
  &.open {
    ${Item} {
      opacity: 1;
      transform: none;
      transition: 0.6s 0.4s cubic-bezier(0, 0.55, 0.45, 1);
      &:nth-of-type(2) {
        transition-delay: 0.5s;
      }
    }
  }

  @media (max-width: 1199px) {
    display: none;
  }
`
